export class TimeFormat {

    static format(totalSeconds: number): string {
        const hours: number = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        const minutes: number = Math.floor(totalSeconds / 60);
        const seconds: number = totalSeconds % 60;
        return [hours, minutes, seconds]
            .map(t => Math.floor(t).toString().padStart(2, '0'))
            .join(':');
    }

}
